import React, { useState, useEffect } from "react";
import CommentBox from "./CommentBox";
// import CommentBox from "./CommentBox_old";
import { Link, withRouter } from "react-router-dom";
import {
  myHeaders_Authorized,
  org_friendly_url,
  user_access_level,
  organization_user_access_level,
  apiUrl,
  myHeaders_Auth_With_Cache_Control,
} from "Api/Api";
import axios from "axios";
import { assembleNickname, getRelativeTime } from "utils/Helper.js";
import avatar from "Assets/avatarnew.svg";
import { local_routes } from "utils/Routes";

import "./style.css";

const PkCommentBox = (props) => {
  const [allow_commenting, set_allow_commenting] = useState(false);
  const [author_avatar, set_author_avatar] = useState(avatar);
  const [loading, set_loading] = useState(true);

  let workspace_base_url = "";
  if (org_friendly_url) {
    workspace_base_url = local_routes.workspace + "/" + org_friendly_url;
  }

  useEffect(() => {
    const fetchData = async () => {
      let allow_commenting = false;
      let adjusted_image_url = avatar;
      if (
        props.entity_info.organizations_uuid &&
        props.entity_info.public_status === "public" &&
        !workspace_base_url
      ) {
        // team-based entity that has been made public - disable comments for now
      } else {
        if (props.user_info.avatar_image_url) {
          let array = props.user_info.avatar_image_url.split("/");
          adjusted_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_50x50/${array[5]}`;
        }
        if (props.user_info.nickname && props.user_info.avatar_image_url) {
          allow_commenting = true;
        }
      }

      set_allow_commenting(true);
      set_loading(false);
      set_author_avatar(adjusted_image_url);
    };
    fetchData();
  });

  // fetch our comments from the API
  const getComments = async () => {
    try {
      // public comments
      let comment_promises = [];
      comment_promises.push(
        axios.get(
          `${apiUrl}${props.entity_type}/${
            props.entity_info.entity_uuid
          }/comments?filter_obj=${encodeURIComponent(
            '{"status_code":{"eq":1}}'
          )}&sort_obj=${encodeURIComponent(
            '{"created_time":"desc"}'
          )}&do_recursive=true`,
          myHeaders_Authorized
        )
      );
      if (props.user_info.entity_uuid) {
        comment_promises.push(
          axios.get(
            `${apiUrl}${props.entity_type}/${
              props.entity_info.entity_uuid
            }/comments?filter_obj=${encodeURIComponent(
              '{"status_code":{"eq":3}}'
            )}&sort_obj=${encodeURIComponent(
              '{"created_time":"desc"}'
            )}&do_recursive=true`,
            myHeaders_Authorized
          )
        );
      }
      let [comments_response, comments_unverified_response] = await Promise.all(
        comment_promises
      );

      let return_comments = [];
      if (comments_unverified_response) {
        return_comments = comments_unverified_response.data.concat(
          comments_response.data
        );
      } else {
        return_comments = comments_response.data;
      }
      // see if comments are approvable, editable or deletable
      return_comments = return_comments.filter((element) => {
        if (element.status_code === 3) {
          if (
            user_access_level === "admin" ||
            organization_user_access_level === "admin" ||
            props.is_owner
          ) {
            element.approvable = true;
            return true;
          } else if (
            element.users &&
            element.users[0] &&
            element.users[0].entity_uuid === props.user_info.entity_uuid
          ) {
            // if current user created this comment, show it as unapproved
            element.unapproved = true;
            return true;
          }
        } else if (element.status_code === 1) {
          if (
            user_access_level === "admin" ||
            organization_user_access_level === "admin" ||
            props.is_owner
          ) {
            element.deletable = true;
          } else if (
            element.users &&
            element.users[0] &&
            element.users[0].entity_uuid === props.user_info.entity_uuid
          ) {
            element.deletable = true;
          }
          return true;
        }
        return false;
      });

      return return_comments;
    } catch (err) {
      console.error("Comments ERROR", err);
    }
  };

  // transform Contentful entries to objects that react-commentbox expects.
  const normalizeComment = (comment) => {
    let adjusted_image_url = avatar;
    if (comment.users[0].avatar_image_url) {
      // if (comment.users && comment.users[0].avatar_image_url) {
      let array = comment.users[0].avatar_image_url.split("/");
      adjusted_image_url = `${array[0]}/${array[1]}/${array[2]}/${array[3]}/${array[4]}/circle_50x50/${array[5]}`;
    }
    let user_profile_link = "";
    // if (comment.users[0].friendly_url && comment.users[0].status_code === 1) {
    if (
      comment.users &&
      comment.users[0].friendly_url &&
      comment.users[0].status_code === 1
    ) {
      user_profile_link =
        workspace_base_url +
        local_routes.users +
        "/" +
        comment.users[0].friendly_url;
    }

    let normalized_comment = {
      id: comment.entity_uuid,
      bodyDisplay: comment.comment_text,
      userNameDisplay: assembleNickname(comment.users[0]),
      timestampDisplay: getRelativeTime(comment.created_time),
      belongsToAuthor: false,
      parentCommentId: null,
      userAvatarUrl: adjusted_image_url,
      user_profile_link,
      status_code: comment.status_code,
      approvable: comment.approvable,
      unapproved: comment.unapproved,
      editable: comment.editable,
      deletable: comment.deletable,
    };

    return normalized_comment;
  };

  // also delete (status_code 2)
  const approveOrDeny = async (new_status_code, comment_uuid) => {
    let patch_obj = {
      status_code: new_status_code,
    };
    await axios.patch(`${apiUrl}comments/${comment_uuid}`, patch_obj);
    // bust cache for public comments
    await Promise.all([
      axios.get(
        `${apiUrl}${props.entity_type}/${
          props.entity_info.entity_uuid
        }/comments?filter_obj=${encodeURIComponent(
          '{"status_code":{"eq":1}}'
        )}&sort_obj=${encodeURIComponent(
          '{"created_time":"desc"}'
        )}&do_recursive=true`,
        myHeaders_Auth_With_Cache_Control
      ),
      axios.get(
        `${apiUrl}${props.entity_type}/${
          props.entity_info.entity_uuid
        }/comments?filter_obj=${encodeURIComponent(
          '{"status_code":{"eq":3}}'
        )}&sort_obj=${encodeURIComponent(
          '{"created_time":"desc"}'
        )}&do_recursive=true`,
        myHeaders_Auth_With_Cache_Control
      ),
    ]);
  };

  const editComment = async (comment_text, comment_uuid) => {
    let patch_obj = {
      status_code: 3,
      comment_text,
    };
    await axios.patch(`${apiUrl}comments/${comment_uuid}`, patch_obj);
    // bust cache for public comments
    await Promise.all([
      axios.get(
        `${apiUrl}${props.entity_type}/${
          props.entity_info.entity_uuid
        }/comments?filter_obj=${encodeURIComponent(
          '{"status_code":{"eq":1}}'
        )}&sort_obj=${encodeURIComponent(
          '{"created_time":"desc"}'
        )}&do_recursive=true`,
        myHeaders_Auth_With_Cache_Control
      ),
      axios.get(
        `${apiUrl}${props.entity_type}/${
          props.entity_info.entity_uuid
        }/comments?filter_obj=${encodeURIComponent(
          '{"status_code":{"eq":3}}'
        )}&sort_obj=${encodeURIComponent(
          '{"created_time":"desc"}'
        )}&do_recursive=true`,
        myHeaders_Auth_With_Cache_Control
      ),
    ]);
  };

  // make an API call to post a comment
  const comment = async (body, parentCommentId) => {
    let tmp_status_code = 3;

    // if user is org-admin, admin, or entity owner, then post comment as status_code 1 (already approved)
    if (
      organization_user_access_level === "admin" ||
      user_access_level === "admin" ||
      props.is_owner
    ) {
      tmp_status_code = 1;
    }

    let post_obj = {
      comment_text: body,
      status_code: tmp_status_code,
      [props.entity_type]: [
        {
          entity_uuid: props.entity_info.entity_uuid,
          xref_data: {
            entity_owner_integer: 1,
          },
        },
      ],
    };

    await axios.post(`${apiUrl}comments`, post_obj);

    // bust cache for public comments
    await Promise.all([
      axios.get(
        `${apiUrl}${props.entity_type}/${
          props.entity_info.entity_uuid
        }/comments?filter_obj=${encodeURIComponent(
          '{"status_code":{"eq":1}}'
        )}&sort_obj=${encodeURIComponent(
          '{"created_time":"desc"}'
        )}&do_recursive=true`,
        myHeaders_Auth_With_Cache_Control
      ),
      axios.get(
        `${apiUrl}${props.entity_type}/${
          props.entity_info.entity_uuid
        }/comments?filter_obj=${encodeURIComponent(
          '{"status_code":{"eq":3}}'
        )}&sort_obj=${encodeURIComponent(
          '{"created_time":"desc"}'
        )}&do_recursive=true`,
        myHeaders_Auth_With_Cache_Control
      ),
    ]);
  };

  const setOrigin = () => {
    window.localStorage.setItem("loginOrigin", props.location.pathname);
  };

  // will be shown when the comment box is disabled
  const disabledComponent = (props) => {
    if (
      props.user_info.entity_uuid &&
      !props.user_info.nickname &&
      !props.user_info.avatar_image_url
    ) {
      return (
        <span>
          Please{" "}
          <Link to={workspace_base_url + local_routes.accountsettings}>
            set your display (first and last) name and your profile avatar image
          </Link>{" "}
          to post comments
        </span>
      );
    } else if (props.user_info.entity_uuid && !props.user_info.nickname) {
      return (
        <span>
          Please{" "}
          <Link to={workspace_base_url + local_routes.accountsettings}>
            set your display (first and last) name
          </Link>{" "}
          to post comments
        </span>
      );
    } else if (
      props.user_info.entity_uuid &&
      !props.user_info.avatar_image_url
    ) {
      return (
        <span>
          Please{" "}
          <Link to={workspace_base_url + local_routes.accountsettings}>
            set your profile avatar image
          </Link>{" "}
          to post comments
        </span>
      );
    } else if (
      props.entity_info.organizations_uuid &&
      props.entity_info.public_status === "public" &&
      !workspace_base_url
    ) {
      return <span>Comments only allowed in Team View</span>;
    } else {
      return (
        <span>
          Please{" "}
          <Link to={local_routes.login} onClick={setOrigin}>
            login
          </Link>{" "}
          to post comments
        </span>
      );
    }
  };

  return (
    <React.Fragment>
      {!loading && (
        <div>
          <CommentBox
            disabled={!allow_commenting}
            getComments={getComments}
            normalizeComment={normalizeComment}
            comment={comment}
            disabledComponent={disabledComponent}
            usersHaveAvatars={true}
            user_avatar_image_url={author_avatar}
            approveOrDeny={approveOrDeny}
            editComment={editComment}
          />
        </div>
      )}
    </React.Fragment>
  );
};

export default withRouter(PkCommentBox);
